import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { FaPlus, FaPen, FaFileLines, FaMagnifyingGlass, FaToggleOn, FaToggleOff, FaDownload } from "react-icons/fa6";

// import EditIcon from '@mui/icons-material/Edit';
// import DescriptionIcon from '@mui/icons-material/Description';
// import AddIcon from '@mui/icons-material/Add';
// import ToggleOnIcon from '@mui/icons-material/ToggleOn';
// import ToggleOffIcon from '@mui/icons-material/ToggleOff';
// import SearchIcon from '@mui/icons-material/Search';
import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText } from '../config/helper';
import '../config/global';
import CTNA from './ct-fragmentna';
import DateTimeFormats from '../config/date-time-format';

const authKey = global.config.kindcode.training[0]+global.config.authBearerKey;

export default class CTUserTrainings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink:"none",
      pageShow: '10',
      keyword: '',
      data_all: [],
      data: []
    }
    this.handleDownload = this.handleDownload.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadContent = this.loadContent.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  urladdUserTraining(currpage) {
    window.location.href=global.config.urlCms+"/"+currpage+'/add';
  }
  handleDownload() {
    var filenames = "users_"+new Date().getTime()+".csv";
    var datatext ='{"keyword":"'+this.state.keyword+'","pageShow":"'+this.state.pageShow+'","filename":"'+filenames+'"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/downloadcsv", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.blob() 
    }).then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filenames;
          a.click();
          window.URL.revokeObjectURL(url);
          document.getElementById('loading-area').style.display = 'none'; 
    }).catch(err => { 
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  handlePublish(valId,nextstat) {
    document.getElementById('loading-area').style.display = 'block';
    // var datatext ='{"feedback_text":"'+content.feedbackText+'","feedback_number":"'+content.feedbackNumber+'","feedback_type":"'+content.feedbackType+'","feedback_status":"'+nextstat+'","option1":"'+content.option1+'","option2":"'+content.option2+'","option3":"'+content.option3+'","option4":"'+content.option4+'","option5":"'+content.option5+'","feedback_docid":"'+valId+'","form_id":"form-edit"}';
    var datatext ='{"user_status":'+nextstat+',"user_docid":"'+valId+'","form_id":"form-publish"}';
    var urlFetch = global.config.urlLink+"/traininguseredit";
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
            // var docId = resJson.values;
            window.location.href=global.config.urlCms+"/"+this.state.activelink;
        } else {
            console.log('Something happened wrong');
        }
        document.getElementById('loading-area').style.display = 'none'; 
        if(resJson.status === '200') {
        } else {
            console.log('Something happened wrong');
        }
    }).catch(err => { 
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }

  handleUserInput = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    var keyw="";
    if(this.textInputKeyword.value === '') { keyw = this.state.keyword; } else { keyw = this.textInputKeyword.value; }
    var resultList = this.state.data_all.sort((a, b) => a.content.memberName > b.content.memberName);
    var resultID = resultList.filter((list) =>  {
      return (list.content.memberName.toLowerCase().match(keyw.toLowerCase()) || list.content.memberEmail.toLowerCase().match(keyw.toLowerCase()));
    });
    this.setState({
      data: resultID
    })
    this.loadContent(resultID)
  }
  loadContent(contents) {
    var userList = [];
    if(contents.length > 0) {
      contents.sort((a, b) => a.content.memberName > b.content.memberName);
      for(var ls=0; ls < contents.length; ls++) {
          var retResult = contents[ls];
          // var editURL = global.config.urlCms+"/"+this.state.activelink+"/edit/"+retResult.docid;
          var viewURL = global.config.urlCms+"/"+this.state.activelink+"/view/"+retResult.docid;
          var iconPub = <FaToggleOff style={{color:"#999999"}} className="styleicons" onClick={this.handlePublish.bind(this, retResult.docid, true)}/>;
          if(retResult.content.flagActive !== undefined && retResult.content.flagActive === true) { iconPub =  <FaToggleOn className="styleicons" onClick={this.handlePublish.bind(this, retResult.docid, retResult.content, false)}/> }

          userList.push(<tr key={retResult.docid}>
              <th scope="row-field">{ls+1}</th>
              {/* <td><img className="border-0 rounded-3" style={{width:"55px"}} src={retResult.content.memberPicture} alt=""/></td> */}
              <td>{retResult.content.registeredDate !== undefined? DateTimeFormats(retResult.content.registeredDate._seconds,"datetime-short") : ''}</td>
              <td>{retResult.content.lastLogin !== undefined? DateTimeFormats(retResult.content.lastLogin._seconds,"datetime-short") : ''}</td>
              <td>{retResult.content.memberName}</td>
              <td>{retResult.content.memberEmail}</td>
              <td>{retResult.content.memberPlan !== undefined? retResult.content.memberPlan : ''}</td>
              <td>
                {/* <a href={editURL}><FaPen className="styleicons" title="edit" /></a> */}
                <a href={viewURL}><FaFileLines className="styleicons" title="view" /></a>
                {iconPub}
              </td>
            </tr>)
      }
    } else {
        userList.push(<tr key="1">
          <th scope="row"></th>
          <td colspan={2} className="d-flex p-3">- no data -</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>)
    }
    return userList;
  }
  loadData() {
    document.getElementById('loading-area').style.display = 'block'; 
    var datatext ='{"keyword":"'+this.state.keyword+'","pageShow":"'+this.state.pageShow+'"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/traininguserlist", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        if(resJson.status === '200') {
          var resultdata = resJson.values.sort((a, b) => a.content.memberName > b.content.memberName);
          this.setState({
              data: resultdata,
              data_all: resultdata
          })
        } else {
          this.setState({
            data: [],
            data_all: []
          })
        }
    }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  componentDidMount() {
    var url = window.location.href;
    var arrUrl = url.split("/");
    // var tabKey = url.substring(url.lastIndexOf('/') + 1);
    var tabKey = arrUrl[arrUrl.length-1];
    if(tabKey === "") {
      tabKey = arrUrl[arrUrl.length-2];
    }
    this.setState({
      activelink: tabKey
    });
    this.loadData();
  }

  render() {
    var userLists = this.loadContent(this.state.data);
    return (
      <div className="setting">
       <Container>
        {
          (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
          (<>
            <div className="row py-5 mb-5">
              {/* === start - body */}
                <div className="col-md-3 bg-light">
                  { 
                    this.state.activelink !== "none" && 
                      <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                  
                  }
                </div>
                <div className="col-md-9 p-4">
                  <div className="row">
                    <div>
                      <h3>{GetText() ? "Pengguna" : "Users"}</h3>
                      <span className="text-muted">{GetText() ? "Daftar Pengguna Novaio Academy" : "List of Users in Novaio Academy"}</span>
                    </div>
                    <div className="mt-3">
                      <div className="row mt-2">
                          <div className="col-6">
                          <form onSubmit={this.handleSubmit} className=" d-flex justify-content-start">
                              <input type="text" className="form-control" name="keyword"
                                placeholder="search name"
                                value={this.state.keyword}
                                onChange={this.handleUserInput}  
                                ref={(input) => this.textInputKeyword = input}/>
                              <FaMagnifyingGlass style={{ fontSize: 35 }} className="styleicons ms-2" onClick={this.handleSubmit} />
                          </form>
                          </div>
                          <div className="col-6 d-flex justify-content-end">
                              {this.state.activelink !== "" && 
                                <div className='row'>
                                <div className="col-2 align-middle">{(localStorage.getItem("ulvl") === global.config.userLevel[0] && localStorage.getItem("email") === "demoreg@mailinator.com") && <a onClick={this.handleDownload} download ><FaDownload style={{ fontSize: 25 }} className="styleicons ms-2"  /></a>  }</div>
                                <div className="col-10 d-flex justify-content-end"><Button variant="secondary" size="sm" onClick={this.urladdUserTraining.bind(this, this.state.activelink)}><FaPlus style={{color:"#FFFFFF", size: "20px"}} className="me-2" />Add New Users</Button> </div>
                                </div>
                              }
                          </div>
                      </div>
                      <div className="mt-3">
                          <table className="table">
                            <thead className="table-dark">
                              <tr key="0">
                              <th width="50" className="text-center" scope="col">#</th>
                              <th scope="col" width="110">Register Date</th>
                              <th scope="col" width="110">Last Login</th>
                              <th scope="col">Name</th>
                              <th scope="col">Email</th>
                              <th scope="col">Status</th>
                              <th width="90" scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                                {userLists}
                            </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              {/* === end - body */}
            </div>
            
            </>
          )
        : 
          <div><CTNA/></div>
        }
        <div id="loading-area" className="d-none loading"></div> 
        </Container>
      </div>
    );
  }
}
